<template>
  <div class="payments-wrap">
    <div class="fixed-header">
    <div class="payment-card" >
      <div class="card-header row align-items-center" @click="toggleHeader" >
        <h3 class="col-7 mb-0 d-flex text-nowrap">
          Payment Details
          <img class="arrow-icon" src="@/assets/icons/arrow-outlined-black.svg" alt="" />
        </h3>
        <div class="value col-5 d-lg-none d-flex justify-content-end">${{ formatNumber(payableCost) }}</div>
        <div class="billing col-5 d-none d-lg-flex" v-if="accountType === 'company'">
          <span style="cursor: pointer" class="monthly" :class="{ sel: localBillingCycle === 'monthly' }"
            @click="updateBillingCycle('monthly')">
            Monthly
          </span>
          <span style="cursor: pointer" class="yearly" :class="{ sel: localBillingCycle === 'yearly' }"
            @click="updateBillingCycle('yearly')">
            Annually
          </span>
        </div>
      </div>
<div class=" d-lg-block" :class="isFixed ? 'd-block' : 'd-none'">
      <div class="divider" />

      <div class="card-body py-1" v-if="accountType === 'company'">
        <div class="card-row" v-show="accountType">
          <span class="label"># of locations</span>
          <span class="value">{{ locations }}</span>
        </div>
        <div class="card-row" v-show="accountType">
          <span class="label"># of users</span>
          <span class="value">{{ users }}</span>
        </div>
        <div class="card-row total" >
          <span class="fw-bold mb-2" >
            Total cost per month
          </span>
          <span class="value">${{ formatNumber(payableCost) }}</span>
        </div>
        <div class="divider" />
      </div>

      <div class="selected-courses">
        <h4>Selected Courses</h4>
        <!-- Skeleton Loading for Cart Processing -->
        <div v-if="isProcessing" class="cart-skeleton">
          <div class="skeleton-course-item" v-for="n in 3" :key="'skeleton-course-' + n">
            <div class="skeleton-course-icon"></div>
            <div class="skeleton-course-name"></div>
            <div class="skeleton-course-price" v-if="accountType !== 'company'"></div>
          </div>
        </div>
        <!-- Actual Courses -->
        <ul v-else class="selected-courses-scroll p-1">
          <li class="course d-flex justify-content-between" v-for="(course, index) in selectedSpecialCourses"
            :key="course.id">
            <span class="text-sm me-4 d-flex">
              <button type="button" class="btn btn-sm btn-link remove-btn p-0 me-2 d-flex align-items-center justify-content-center"
                :disabled="planCourses && planCourses.includes(course.id)" @click="removeSpecialCourse(course.id)"
                title="Remove course">
                <img :style="{
                  filter: planCourses && planCourses.includes(course.id) ? 'grayscale(1)' : 'none',
                  opacity: planCourses && planCourses.includes(course.id) ? 0.5 : 1,
                  transition: 'filter 0.3s ease, opacity 0.3s ease'
                }" src="@/assets/icons/red-minus.svg" alt="Remove course" width="15px" />
              </button>
              <span>{{ course.name }}</span>
            </span>
          </li>
          <li class="course d-flex justify-content-between" v-for="(course, index) in sortedCourses" :key="index">
            <span class="text-sm me-4 d-flex">
              <button type="button" class="btn btn-sm btn-link remove-btn p-0 me-2 d-flex align-items-center justify-content-center"
                :disabled="planCourses && planCourses.includes(course.id)" @click="removeCourse(course.id)"
                title="Remove course">
                <img :style="{
                  filter: planCourses && planCourses.includes(course.id) ? 'grayscale(1)' : 'none',
                  opacity: planCourses && planCourses.includes(course.id) ? 0.5 : 1,
                  transition: 'filter 0.3s ease, opacity 0.3s ease'
                }" src="@/assets/icons/red-minus.svg" alt="Remove course" width="15px" />
              </button>
              <span>{{ course.name }}</span>
            </span>
            <span v-show="accountType !== 'company'" class="ms-4 text-muted text-sm">${{ formatNumber(course.cost) }}</span>
          </li>
        </ul>
      </div>

      <div class="divider" />
      <div class="card-body py-1" v-if="localBillingCycle === 'yearly' || accountType === 'individual'">
        <div class="card-row total" v-if="localBillingCycle === 'yearly' && accountType === 'company'">
          <span class="fw-bold mb-2">
            Annually(10% off)
          </span>
          <span class="value">${{ formatNumber(displayCost) }}</span>
        </div>
        <div class="card-row total" v-if="accountType === 'individual'">
          <h6 class="label mb-0" >
            Amount Payable
          </h6>
          <span class="value">${{ formatNumber(payableCost) }}</span>
        </div>
         <div class="divider" />
      </div>

      <div class="payemnt-card-footer">
        <div v-if="!promoApplied" class="discount" @click="toggleDiscountSection">
          <button class="discount-toggle">Have a Discount Code?</button>
          <img src="@/assets/icons/arrow-outlined.svg" alt="" :class="{ 'rotated': showDiscountCode }" />
        </div>

        <!-- Show applied promo summary -->
        <div v-if="promoApplied" class="d-flex justify-content-between mb-2">
          <span class="promocode-applied m-0">
            Promotional Discount Applied ({{ promoDiscount }}%)
          </span>
          <span style="cursor: pointer;" class="promocode-applied" @click="removePromo">
            <i class="fas fa-times"></i>
          </span>
        </div>

        <!-- Show promo input if not applied -->
        <div v-else-if="showDiscountCode" class="d-flex align-items-center discount-code">
          <input v-model="promoCode" placeholder="x x x x" />
          <base-button class="apply-btn" @click="applyPromo">Apply</base-button>
        </div>

        <button class="pay-btn"
          :class="(selectedCourses.length > 0 || selectedSpecialCourses.length > 0) ? 'active-btn' : ''"
          :disabled="selectedCourses.length === 0 && selectedSpecialCourses.length === 0 || isProcessing"
          @click="$emit('trigger-submit')">
          <span v-if="isProcessing" class="d-flex align-items-center justify-content-center">
            <span class="skeleton-spinner me-2"></span>
            Processing...
          </span>
          <span v-else>{{ buttonText }}</span>
        </button>


      </div>
      <div class="trusted m-2 d-sm-none  d-lg-none mt-0">
          <div class="security-logos-container">
            <div class="text-center mb-2">
              <img class="p-2" src="@/assets/security/259.png" alt=""/>
              <img class="p-2" src="@/assets/security/261.png" alt=""/>
              <img class="p-2" src="@/assets/security/263.png" alt=""/>
              <img class="p-2" src="@/assets/security/264.png" alt=""/>
            </div>
          </div>
        </div>
    </div>
    </div>
    </div>

    <!-- Live Chat -->
    <div class="live-chat" aria-hidden>
      <div class="live-content">
        <div class="live-text">
          <h4>Live Chat</h4>
          <p>
            See how Home of Training simplifies staff onboarding and training in
            just minutes.
          </p>
        </div>
        <a href="mailto:support@homeoftraining.com" class="get-started">Get Started</a>

        <div class="live-illustration" aria-hidden>
          <img src="@/assets/icons/digital-marketing.svg" alt="" />
        </div>
      </div>
    </div>

    <!-- Demo Card -->
    <schedule-demo />

  </div>
</template>

<script>
import BaseInput from "../Inputs/BaseInput.vue";
import ScheduleDemo from "../../components/Signup/ScheduleDemo";

export default {
  name: "PaymentsDetails",
  components: { BaseInput, ScheduleDemo },
  props: {
    accountType: String,
    billingCycle: String,
    locations: Number,
    users: Number,
    selectedCourses: Array,
    selectedSpecialCourses: {
      required: true
    },
    totals: Object,
    selectedPlan: {
      type: Object,
      required: false,
      default: null
    },
    plan: {
      type: Object,
      required: true
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDiscountCode: false,
      localBillingCycle: this.billingCycle,
      promoCode: "",
      loadingPromo: false,
      promoApplied: false,
      promoDiscount: 0,
      isFixed: false,

    };
  },
  computed: {
    sortedCourses() {
      const planCourseIds = (this.selectedPlan?.courses || []);
      return [...this.selectedCourses].sort((a, b) => {
        const aInPlan = planCourseIds.includes(a.id);
        const bInPlan = planCourseIds.includes(b.id);
        if (aInPlan === bInPlan) return 0;
        return aInPlan ? 1 : -1;
      });
    },
    planCourses() {
      return this.selectedPlan?.courses || []
    },
    payableCost() {
      const cost = this.totals?.total_monthly_cost;
      return cost ? cost.toFixed(2) : '0.00';
    },

    buttonText() {
      return this.accountType === "company"
        ? "Pay Now — Enjoy 15 Days On Us!"
        : "Pay Now";
    },
    displayCost() {
      const monthly = this.totals?.total_monthly_cost || 0;
      const yearly = this.totals?.total_annually_cost || 0;
      return this.localBillingCycle === "yearly"
        ? yearly.toFixed(2)
        : monthly.toFixed(2);
    },
  },
  watch: {
    billingCycle(newVal) {
      this.localBillingCycle = newVal;
    },
  },
  methods: {
    toggleHeader() {
      this.isFixed = !this.isFixed;
    },
    updateBillingCycle(cycle) {
      if (this.localBillingCycle !== cycle) {
        this.localBillingCycle = cycle;
        this.$emit("change-billing-cycle", cycle);
      }
    },

    toggleDiscountSection() {
      if (!this.promoApplied) this.showDiscountCode = !this.showDiscountCode;
    },

    applyPromo() {
      if (!this.promoCode.trim()) return;
      this.loadingPromo = true;

      this.$http
        .post("promocode/apply_promocode", {
          promocode: this.promoCode,
          amount: this.totals.total_monthly_cost,
        })
        .then((res) => {
          const data = res.data;

          const newTotals = {
            total_monthly_cost: data.final_amount ?? this.totals.total_monthly_cost,
            total_annually_cost: data.final_amount
              ? data.final_amount * 12
              : this.totals.total_annually_cost,
            discount: data,
          };

          this.promoApplied = true;
          this.promoDiscount = data.discount_percentage;

          this.$emit("promo-applied", newTotals, this.promoCode);

          this.$toast?.success?.(
            `Promo applied: ${data.discount_percentage}% off`,
            { timeout: 5000 }
          );
        })
        .catch((err) => {
          const msg =
            err.response?.data?.message || "Invalid or expired promo code.";
          this.$toast?.error?.(msg, { timeout: 5000 });
        })
        .finally(() => {
          this.loadingPromo = false;
        });
    },
    removeCourse(courseId) {
      if (!this.planCourses.includes(courseId)) {
        this.$emit("remove-course", courseId);
      }
    },
    removeSpecialCourse(courseId) {
      if (!this.planCourses.includes(courseId)) {
        this.$emit("remove-special-course", courseId);
      }
    },
    removePromo() {
      this.promoCode = "";
      this.promoApplied = false;
      this.promoDiscount = 0;
      this.$emit("promo-applied", this.totals, null);
      this.$toast?.info?.("Promo code removed", { timeout: 3000 });
    },
    formatNumber(num) {
      if (!num && num !== 0) return "0.00";
      return parseFloat(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // openMail() {
    //   const subject = encodeURIComponent("Inquiry about Home of Training");
    //   window.location.href = "mailto:mailto:support@homeoftraining.com?subject=" + subject;
    // },
  },
};
</script>

<style lang="scss" scoped>
.payments-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

// Payment details Card
.payment-card {
  border-radius: 12px;
  overflow: hidden;
  color: #1b0f0b;
  background: linear-gradient(90deg,
      rgba(228, 151, 58, 0.09) 0,
      rgba(235, 26, 38, 0.18));

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;

    .arrow-icon {
      margin-left: 10px;
      display: block;
    }

    h3 {
      font-size: 20px;
      line-height: 25px;
      font-weight: 700;
      color: #252525;
      margin: 0;
    }

    .billing {
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 23px;

      span {
        font-size: 13px;
        line-height: 20px;
        font-weight: 600;
        color: #252525;
      }

      .sel {
        color: #ea2527 !important;
      }
    }
  }

  .card-body {
    padding: 24px 20px;

    .card-row {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      align-items: center;
    }

    .row.total {
      font-weight: 700;
      padding-top: 12px;
    }

    .label {
      font-size: 16px;
      line-height: 20px;
      color: #252525;
    }

    .value {
      font-size: 16px;
      line-height: 20px;
      color: #252525;
    }
  }

  .divider {
    height: 1px;
    background: rgba(0, 0, 0, 0.08);
  }

  .selected-courses {
    padding: 24px 20px;

    h4 {
      font-size: 16px;

      font-weight: 800;
      margin-bottom: 10px;
      color: #252525;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .course {
      display: flex;
      gap: 10px;
      align-items: center;
      padding: 6px 0;
      color: rgba(0, 0, 0, 0.7);
    }

    .course-dot {
      display: inline-flex;
      width: 18px;
      height: 18px;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.35);
      color: #7a2b22;
      font-weight: 700;
    }

    .course-dot.remove {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .selected-courses-scroll {
    max-height: 250px;
    overflow-y: auto;
  }

  .payemnt-card-footer {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 20px;

    .discount {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .discount-toggle {
      background: transparent;
      border: none;
      color: #ea2527;
      font-weight: 600;
      cursor: pointer;
    }

    .active-btn {
      background: linear-gradient(135deg, rgb(228, 151, 58) 0%, rgb(235, 26, 38) 100%) !important;
    }

    .discount-code {
      width: 100%;
      gap: 12px;
      flex: 1;

      input {
        flex: 1;
        background-color: transparent;
        border: 1px solid rgba(0, 0, 0, 0.08);
        padding: 15px 19px;
        border-radius: 12px;

        &:focus {
          outline: none;
          border-color: rgba(228, 151, 58, 1);
        }
      }

      .apply-btn {
        background: rgba(228, 151, 58, 1);
        color: #ffffff;
        padding: 12px 16px;
        border-radius: 12px;
        font-weight: 700;
        font-size: 12px;
        line-height: 15px;
        border: none;
        cursor: pointer;
        min-width: fit-content;
        border-radius: 12px !important;
      }
    }

    .pay-btn {
      display: block;
      width: 100%;
      background: #a6a6a6;
      color: #ffffff;
      padding: 12px 16px;
      border-radius: 8px;
      font-weight: 700;
      font-size: 15px;
      line-height: 18px;
      border: none;
      cursor: pointer;
    }
  }
}

/* placeholders */
.live-chat,
.demo-card {
  border-radius: 15px;
  background: #fff;
  border: 1px solid rgba(235, 26, 38, 0.2);
}

// Live Chat
.live-chat {
  padding: 18px;
  border: 1px solid rgba(255, 106, 74, 0.12);
  box-shadow: 0 6px 18px rgba(255, 106, 74, 0.04);
  position: relative;

  .live-content {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .live-text {
    h4 {
      margin: 0 0 6px 0;
      color: rgba(234, 37, 39, 1);
      font-size: 16px;
      line-height: 18px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    p {
      margin: 0 0 12px 0;
      color: rgba(0, 0, 0, 0.7);
      font-size: 12px;
      line-height: 15px;
    }
  }

  .get-started {
    display: inline-block;
    background: transparent;
    border: 1px solid rgba(234, 37, 39, 1);
    color: rgba(234, 37, 39, 1);
    padding: 10px 15px;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
    font-size: 12px;
    line-height: 15px;
    width: fit-content;
    text-decoration: none;
  }

  .live-illustration {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

// Demo Card
.demo-card {
  background: rgba(232, 83, 47, 0.03);
  color: rgba(255, 255, 255, 0.9);
  padding: 22px 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;

  .demo-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .demo-text h4 {
    margin: 0;
    font-size: 16px;
    line-height: 18px;
    font-weight: 700;
    color: rgba(234, 37, 39, 1);
  }

  .demo-cta .schedule-btn {
    background: transparent;
    border: 1px solid rgba(234, 37, 39, 1);
    color: rgba(234, 37, 39, 1);
    padding: 8px 12px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
  }
}


@media (min-width: 1024px) {
  .payments-wrap {
    gap: 20px;
  }

  .payment-card {
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 20px;

      .arrow-icon {
        margin-left: 0px;
        display: none;
      }

      h3 {
        font-size: 20px;
        line-height: 25px;
        font-weight: 700;
        color: #252525;
        margin: 0;
      }

      .billing {
        display: flex;
        align-items: center;
        gap: 23px;

        span {
          font-size: 13px;
          line-height: 20px;
          font-weight: 600;
          color: #252525;
        }

        .sel {
          color: #ea2527 !important;
        }
      }
    }

    border-radius: 12px;

    .payemnt-card-footer {
      padding: 24px 20px;

      .discount {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .discount-toggle {
        background: transparent;
        border: none;
        color: #ea2527;
        font-weight: 600;
        cursor: pointer;
      }

      .discount-code {
        gap: 12px;

        input {
          flex: 1;
          background-color: transparent;
        }

        .apply-btn {
          padding: 16px 32px;
          font-size: 14px;
          line-height: 20px;
        }
      }

      .pay-btn {
        display: block;
        width: 100%;
        background: #a6a6a6;
        color: #ffffff;
        padding: 12px 16px;
        border-radius: 8px;
        font-weight: 700;
        font-size: 15px;
        line-height: 18px;
        border: none;
        cursor: pointer;
      }
    }
  }

  .promocode-applied {
    color: #ea2527;
  }

  // Live Chat
  .live-chat {
    padding: 18px;
    border: 1px solid rgba(255, 106, 74, 0.12);
    box-shadow: 0 6px 18px rgba(255, 106, 74, 0.04);
    position: relative;

    .live-content {
      display: flex;
      justify-content: start;
      flex-direction: column;
      gap: 30px;
    }

    .live-text {
      h4 {
        margin: 0 0 6px 0;
        color: rgba(234, 37, 39, 1);
        font-size: 16px;
        line-height: 18px;
        font-weight: 700;
        margin-bottom: 16px;
      }

      p {
        margin: 0 0 12px 0;
        color: rgba(37, 37, 37, 1);
        font-size: 12px;
        line-height: 15px;
      }
    }

    .get-started {
      display: inline-block;
      background: transparent;
      border: 1px solid rgba(234, 37, 39, 1);
      color: rgba(234, 37, 39, 1);
      padding: 10px 15px;
      border-radius: 10px;
      font-weight: 500;
      cursor: pointer;
      font-size: 12px;
      line-height: 15px;
    }

    .live-illustration {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }

  // Demo Card
  .demo-card {
    background: rgba(232, 83, 47, 0.03);
    color: rgba(255, 255, 255, 0.9);
    padding: 22px 20px;
    border-radius: 12px;
    display: flex;
    align-items: center;

    .demo-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .demo-text h4 {
      margin: 0;
      font-size: 16px;
      line-height: 18px;
      font-weight: 700;
      color: rgba(234, 37, 39, 1);
    }

    .demo-cta .schedule-btn {
      background: transparent;
      border: 1px solid rgba(234, 37, 39, 1);
      color: rgba(234, 37, 39, 1);
      padding: 8px 12px;
      border-radius: 10px;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
    }
  }
}

.discount img {
  transition: transform 0.3s ease;
}

.discount img.rotated {
  transform: rotate(180deg);
}
@media (max-width: 768px) {
  .fixed-header {
    position: fixed;
    z-index: 999;
    bottom: 0%;
    background: antiquewhite;
    width: 95%;
  }
  .fixed-header-move {
    bottom: 0 !important;
  }
  .payment-card .selected-courses-scroll {
    max-height: 100px;
  }
}
.security-logos-container img{
  mix-blend-mode: multiply;
}

// Cart Processing Skeleton Styles
.cart-skeleton {
  padding: 10px 0;
}

.skeleton-course-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}

.skeleton-course-icon {
  width: 15px;
  height: 15px;
  border-radius: 2px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

.skeleton-course-name {
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  flex: 1;
  max-width: 150px;
  
  @media (max-width: 768px) {
    max-width: 120px;
  }
}

.skeleton-course-price {
  width: 60px;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  margin-left: auto;
}

.skeleton-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
